import { topicZones } from "@/mocks/homeData";

const accentMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800",
  accent: "bg-accent-100 text-accent-900",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function TopicZones() {
  return (
    <section id="zones" className="w-full border-b border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 md:mb-10">
          <p className="mb-2 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.25em] text-accent-700">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-layout-grid-line text-sm" />
            </span>
            Zones
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜话题分区
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500 md:text-base">
            按场景分区，挑一个合口味的进去，闲聊也好，认真讨论也罢。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {topicZones.map((zone) => (
            <a
              key={zone.id}
              href="#discussion"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="h-44 w-full overflow-hidden bg-background-200">
                <img
                  src={zone.image}
                  alt={`${zone.name} - 黑料八卦话题分区封面`}
                  title={`${zone.name}话题分区`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span
                  className={`mb-3 self-start rounded-full px-2.5 py-1 text-xs font-medium ${accentMap[zone.color]}`}
                >
                  {zone.count}
                </span>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {zone.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-500">
                  {zone.desc}
                </p>
                <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
                  进去看看
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-line text-sm" />
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}